import _ from 'lodash';
import React, { Component } from 'react';

import Goal from './goalTemplates';

class FourboxSection extends Component {

  renderGoalsForSection(){
    const goals = this.props.sectionGoals || [];

    return (
      <ul className="section-goals">
        {_.map(goals, goal => {
          return <Goal
            editable={this.props.editable}
            key={goal.id}
            goal={goal}
            updateGoalValue={this.props.updateGoalValue}
            updateGoalMeta={this.props.updateGoalMeta}
            updateCustomGoalValues={this.props.updateCustomGoalValues}
            trackGoal={this.props.trackGoal}
            localizations={this.props.localizations}
            anticipatedSubmissionDate={this.props.anticipatedSubmissionDate}
            endDate={this.props.endDate}
          />
        })}
      </ul>
    )
  }

  render(){
    const { sectionClass, sectionName } = this.props;
    return (
      <div className={'fourbox-section ' + (sectionClass || '')}>
        <h6>{sectionName}</h6>
        {this.renderGoalsForSection()}
      </div>
    )
  }
}

export default FourboxSection;



// WEBPACK FOOTER //
// ./src/components/sprint/fourboxSection.js